import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tyt-clip-tag',
  templateUrl: './clip-tag.component.html',
  styleUrls: ['./clip-tag.component.scss']
})
export class ClipTagComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
